import {
  FETCH_BANNER_REQUEST,
  FETCH_BANNER_SUCCESS,
  FETCH_BANNER_FAIL,
} from '../constants/actionTypes';

const fetchBannerRequest = () => ({
  type: FETCH_BANNER_REQUEST,
});

const fetchBannerSuccess = (payload) => ({
  type: FETCH_BANNER_SUCCESS,
  payload
});

const fetchBannerFail = () => ({
  type: FETCH_BANNER_FAIL,
});

export { fetchBannerRequest, fetchBannerSuccess, fetchBannerFail };
